import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import styled from 'styled-components';
import styles from '../../../styles';
import { ColumnBlock, ColumnContent } from '../../layout/components';
import { PreloadImage } from '../../pages/components';

import { TextLink } from './';
import { stripWPPath } from '../../../utils/stripWPPath';

import * as navigationActions from '../../navigation/navigation.actions';

const HoverBlock = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${styles.color.ORANGE};
  //opacity: 0.95;
  //transform: translate3d(-100%, 0, 0);
  transform: translateX(-100%);
  transition: transform 0.5s ${styles.easing.inOutCubic};
  transition-delay: 0s;

  .hover & {
    //transform: translate3d(100%, 0, 0);
    transform: translateX(100%);
  }
`;

const ImageBlockWrapper = styled.div`
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props.breakpoint === 'tablet' ? 1.875 : 3.75}rem;
  padding-right: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props.breakpoint === 'tablet' ? 1.875 : 3.75}rem;
`;

const ImageBlock = styled(ColumnBlock)`
  text-align: center;
  margin-left: 0;
  overflow: visible;
  display: block;
  figure {
    /*
    width: ${props =>
      props.breakpoint === 'desktop'
        ? 74.1935483870968
        : props.breakpoint === 'tablet' ? 83.739837398374 : 100}%;
    padding-top: ${props =>
      props.breakpoint === 'desktop'
        ? 74.1935483870968
        : props.breakpoint === 'tablet' ? 83.739837398374 : 100}%;
    */
    width: 100%;
    padding-top: 100%;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    img {
      transform: scale(1);
      transform-origin: 50% 50%;
      transition-property: transform;
      transition-timing-function: ${styles.easing.inOutQuad};
      transition-duration: 0.25s;
    }

    .current-input-mouse &:hover {
    img {
      transform: scale(1.2);
    }
  }
/*
    &:after {
      background: rgba(0, 0, 0, 0.1);
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 1;

      transform: scale(1, 1);
      transform-origin: 100% 50%;
      transition-property: transform;
      transition-timing-function: ${styles.easing.inOutCubic};
      transition-duration: 0.35s;
      transition-delay: 0.05s;
    }
*/
    ${props =>
      (props.narrow || props.breakpoint === 'phone') &&
      `
      margin-bottom: 2.25rem;
    `} img {
      width: 100%;
      height: auto;
    }
  }
`;

const ContentBlock = styled(ColumnBlock)`
  ${props =>
    props.columns === 1 &&
    !props.narrow &&
    `
    margin-right: 0;
  `} h4 {
    font-family: 'ApercuMono';
    font-size: 1rem;
    margin-bottom: 1rem;
    text-transform: uppercase;
    color: ${styles.color.SLATE};
  }
  h2 {
    margin-bottom: 1rem;
    color: ${styles.color.BLACK};
    transition: color 0.35s ${styles.easing.inOutCubic};
  }

  .hover & {
    h2 {
      color: ${styles.color.SLATE};
    }
  }
`;

const StyledColumnBlock = styled(ColumnBlock)`
  cursor: pointer;
  margin-bottom: 8.5rem;
/*
  .current-input-mouse &:hover,
  .current-input-touch &:active {
    ${ImageBlock} {
      figure {
        &:after {
          transform: scale(0, 1);
          transition-delay: 0.0s;
        }
      }
    }
  }
  */
`;

const StyledContent = styled(ColumnContent).attrs({
  paddingLeft: props =>
    props.breakpoint === 'desktop' && props.withPadding
      ? '3.75rem'
      : '1.875rem',
  paddingRight: props =>
    props.breakpoint === 'desktop' && props.withPadding
      ? '3.75rem'
      : '1.875rem',
})`
  //max-width: ${props =>
    props.breakpoint === 'desktop' && props.maxWidth
      ? props.maxWidth
      : 'unset'};
`;

class CrossLinkBlock extends PureComponent {
  state = {
    hover: false,
  };

  onMouseOver = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseOut = () => {
    this.setState({
      hover: false,
    });
  };

  onClick = e => {
    const { navigate, linkTarget } = this.props;
    e.preventDefault();
    e.stopPropagation();

    const url = stripWPPath(linkTarget);
    const isExternal = url === linkTarget && url.indexOf('://') > -1;

    if (!isExternal) {
      navigate(url);
    } else {
      window.open(url);
    }
    return false;
  };

  render() {
    const {
      breakpoint,
      image,
      fullWidth,
      narrow,
      children,
      category,
      linkLabel,
      linkTarget,
    } = this.props;
    const numContainerColumns = narrow ? 1 : 2;
    const numContentBlockColumns = narrow || image ? 1 : 2;
    const className = classnames({
      hover: this.state.hover,
    });

    return (
      <StyledColumnBlock
        parentColumns={fullWidth ? numContainerColumns : null}
        columns={numContainerColumns}
        flex
        className={className}
        onMouseEnter={this.onMouseOver}
        onMouseLeave={this.onMouseOut}
        onTouchStart={this.onMouseOver}
        onTouchEnd={this.onMouseOut}
        onClick={this.onClick}
      >
        {image && (
          <ImageBlock
            narrow={narrow}
            parentColumns={numContainerColumns}
            breakpoint={breakpoint}
          >
            <ImageBlockWrapper breakpoint={breakpoint}>
              <figure>
                <PreloadImage src={image} />
                {/*<HoverBlock />*/}
              </figure>
            </ImageBlockWrapper>
          </ImageBlock>
        )}
        <ContentBlock
          columns={numContentBlockColumns}
          parentColumns={numContainerColumns}
          narrow={narrow}
        >
          <StyledContent breakpoint={breakpoint} withPadding={narrow || !image}>
            {category && <h4>{category}</h4>}
            {children}
            <footer>
              <TextLink isMouseOver={this.state.hover} to={linkTarget}>
                {linkLabel}
              </TextLink>
            </footer>
          </StyledContent>
        </ContentBlock>
      </StyledColumnBlock>
    );
  }
}

CrossLinkBlock.propTypes = {
  breakpoint: PropTypes.string,
  image: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  narrow: PropTypes.bool,
  fullWidth: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  category: PropTypes.string,
  linkLabel: PropTypes.string,
  linkTarget: PropTypes.string,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, navigationActions)(CrossLinkBlock);



// WEBPACK FOOTER //
// ./src/modules/pages/components/CrossLinkBlock.js